import React from 'react';

import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';
import { Text } from 'components/v2/Typography/Text';

import { AppleModalProps } from './AppleDisclaimerModal.types';

const AppleNotLoadedModal = (props: AppleModalProps) => {
  return (
    <Modal open={props.showModal} onCancel={props.handleClose} title="Apple not loaded disclaimer">
      <Text size="md">Apple sign-in failed to load. Please try refreshing your web browser.</Text>
      <Button label="Refresh" onClick={props.handleClose} />
    </Modal>
  );
};

export default AppleNotLoadedModal;
